import React, { FC, useState, useContext } from "react";
import { Link } from "react-router-dom";

import { SessionType } from "@/features/training/model/Training/TrainingDrill";
import { EditTrainingDrill } from "@/features/training/ui";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import EngineeringIcon from "@mui/icons-material/Engineering";
import { Box, IconButton, Tooltip } from "@mui/material";
import { TreeItem } from "@mui/x-tree-view/TreeItem";
import { Language } from "@/model/Language/Language";

import { TranslationContext } from "@/app/providers";

import { GetLanguageValueAsString } from "@/app/application/Translate";


interface TreeExerciseItemProps {
	id: number;
	name: string;
}

/** Row-only component that doesn't mount a modal inside the TreeItem */
const Row: FC<{ id: number; name: string; onEdit: () => void }> = ({
	id,
	name,
	onEdit,
}) => {
	const translation: Language | null = useContext(TranslationContext);

	return (
		<TreeItem
			itemId={`exercise-${id}`}
			label={
				<Box
					id={`tree-node-exercise-${id}`}
					sx={{ display: "flex", alignItems: "center", width: "100%" }}
				>
					<EngineeringIcon sx={{ mr: 1 }} />
					<Link
						to={`/training/drills/${id}`}
						className="accordion-item-link accordion-item-link-action"
					>
						{name}
					</Link>

					<Box sx={{ ml: "auto" }}>
						<Tooltip title={GetLanguageValueAsString(translation, "Auto.Features.Training.Pages.DrillTab.PanelLeft.Accordion.TreeExerciseItem.L38C21.EditDrill", "Edit drill")} disableInteractive>
							<span>
								<IconButton
									size="small"
									onMouseDown={(e) => e.stopPropagation()} // prevent tree focus/toggle
									onClick={(e) => {
										e.stopPropagation();
										onEdit();
									}}
									sx={{ opacity: 0.6, "&:hover": { opacity: 1 } }}
									aria-label={GetLanguageValueAsString(translation, "Auto.Features.Training.Pages.DrillTab.PanelLeft.Accordion.TreeExerciseItem.L48C20.EditDrill", "Edit drill")}
								>
									<EditOutlinedIcon fontSize="small" />
								</IconButton>
							</span>
						</Tooltip>
					</Box>
				</Box>
			}
		/>
	);
};

export const TreeExerciseItem: FC<TreeExerciseItemProps> = ({ id, name }) => {
	const [open, setOpen] = useState(false);

	return (
		<>
			<Row id={id} name={name} onEdit={() => setOpen(true)} />

			{/* IMPORTANT: mount the dialog OUTSIDE the tree row so inputs are editable */}
			<EditTrainingDrill
				id={id}
				type={SessionType.Exercise}
				open={open}
				handleClose={() => setOpen(false)}
			/>
		</>
	);
};

export default TreeExerciseItem;
